angular.module('impactx.sidebar').controller('SideBarSubMenuCtrl', [
    '$location',
    'basketTemplateMenu',
    'CustomerService',
    'DownloadService',
    'HelpService',
    'ManualOrderCreationService',
    SideBarMenuItemCtrl
]);

function SideBarMenuItemCtrl($location, basketTemplateMenu, CustomerService, DownloadService, HelpService, ManualOrderCreationService) {
    var self = this;
    self.itemHeight = 42;

    self.isActive = function(path) {
        path = "/" + path;
        return $location.path() === path;
    };

    self.toggleOpen = function(item) {
        item.subHeight > 0 ? item.subHeight = 0 : item.subHeight = self.itemHeight * item.subitems.length;
    };

    self.getHeight = function(item) {
        var height = item.subHeight;
        if((item.subHeight == undefined && item.showOpen) || item.subHeight > 0) {
            if(item.view == 'mylist') {
                item.subHeight = self.itemHeight * (item.subitems.length +
                    basketTemplateMenu.getOwnTemplates().subitems.length +
                    basketTemplateMenu.getOwnCompanyTemplates().subitems.length +
                    basketTemplateMenu.getCompanyTemplates().subitems.length)
            }
            else {
                item.subHeight = self.itemHeight * item.subitems.length
            }
        }
        return height;
    };

    self.triggerMenuAction = function (item, event) {
        if (item.action) {
            if (item.action == 'customerservice') {
                CustomerService.openPanel();
            }
            else if (item.action == 'contractPage') {
                DownloadService.openDownloadPost('/contractpage/download');
            }
            else if(item.action == 'help') {
                HelpService.open();
            }
            else if(item.action == 'manualordercreation') {
                ManualOrderCreationService.openCreationDialog(event);
            }
        }
    }
}
